import { render } from "./ButtonTabletFormComponentDetails.vue?vue&type=template&id=ea658040"
import script from "./ButtonTabletFormComponentDetails.vue?vue&type=script&lang=js"
export * from "./ButtonTabletFormComponentDetails.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__